"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StoryPointInfoImpl = /** @class */ (function () {
    function StoryPointInfoImpl(_caption, _index, _storyPointId, _active, _updated, _parentStoryImpl) {
        this._caption = _caption;
        this._index = _index;
        this._storyPointId = _storyPointId;
        this._active = _active;
        this._updated = _updated;
        this._parentStoryImpl = _parentStoryImpl;
    }
    Object.defineProperty(StoryPointInfoImpl.prototype, "caption", {
        get: function () {
            return this._caption;
        },
        set: function (caption) {
            this._caption = caption;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointInfoImpl.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (index) {
            this._index = index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointInfoImpl.prototype, "storyPointId", {
        get: function () {
            return this._storyPointId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointInfoImpl.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (isActive) {
            this._active = isActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointInfoImpl.prototype, "updated", {
        get: function () {
            return this._updated;
        },
        set: function (isUpdated) {
            this._updated = isUpdated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StoryPointInfoImpl.prototype, "parentStory", {
        get: function () {
            return this._parentStoryImpl;
        },
        enumerable: true,
        configurable: true
    });
    return StoryPointInfoImpl;
}());
exports.StoryPointInfoImpl = StoryPointInfoImpl;
//# sourceMappingURL=StoryPointInfoImpl.js.map